import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from './PageHeader';
import PageBody from './PageBody';
import { usePage } from '../PageContext';
import HeaderImage from '../assets/images/banner-img.jpg';
import { Container,Spinner, Stack } from 'react-bootstrap';
import DynamicPopup from './DynamicPopup';
function DynamicPage() 
{
  const { currentPage } = usePage();
  const { i18n } = useTranslation();
  const location = useLocation();
  const appLanguage = localStorage.getItem('appLanguage') || 'en';
  var errorPage = {"sp_id":0,"sp_dynamic":1,"sp_name":"404 - Page Not Found","sp_name_hi":"404 - पेज नहीं मिला"};
  const[isLoading, setLoading] = useState(true);
  const[PageData,setPage] = useState([]);
  const[showPopup, setShowPopup] = useState(false);
  const[popupData, setPopupData] = useState(null);
  const[LavelZero,setLavelZero] = useState("");
  const[LavelOne,setLavelOne] = useState("");
  const[LavelTwo,setLavelTwo] = useState("");
  const[LavelThree,setLavelThree] = useState("");
  const[PageUrl,setPageUrl] = useState("");
  useEffect(() => 
  {
    setLavelZero("");
    setLavelOne("");
    setLavelTwo("");
    setLavelThree("");
    setPageUrl("");
    const urlHas = location.pathname.split('/').filter(Boolean);
    if (urlHas.length > 0)
    {
      const CurrentPath = decodeURIComponent(window.location.pathname);    
      const hindiRegex = /[\u0900-\u097F]/;
      const isHindi = hindiRegex.test(CurrentPath);
      if (isHindi && appLanguage !== 'hi') {
        localStorage.setItem('appLanguage', 'hi');
        i18n.changeLanguage('hi');
      } 
      else if (!isHindi && appLanguage !== 'en') {
        localStorage.setItem('appLanguage', 'en');
        i18n.changeLanguage('en');
      }
    }       
    //console.log(urlHas);
    const loadPageData = async () => {
      if (urlHas.length > 0)
      {
        if( (urlHas.at(0) === 'event' || decodeURIComponent(urlHas.at(0)) === 'घटनाक्रम') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          const sidebarData = await getSidebar([],191);
          setPage({sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'EventDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'EventDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'notice' || decodeURIComponent(urlHas.at(0)) === 'नोटिस') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          const sidebarData = await getSidebar([],191);
          setPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'NoticeDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'NoticeDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'achievement' || decodeURIComponent(urlHas.at(0)) === 'उपलब्धि') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          const sidebarData = await getSidebar([],191);
          setPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'AchievementDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'AchievementDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'exam' || decodeURIComponent(urlHas.at(0)) === 'परीक्षा') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          const sidebarData = await getSidebar([],191);
          setPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'ExamDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'ExamDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'profile' || decodeURIComponent(urlHas.at(0)) === 'प्रोफ़ाइल') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          setPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'FacultyDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'FacultyDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'profile' || decodeURIComponent(urlHas.at(0)) === 'प्रोफ़ाइल') && (urlHas.at(1) === 'publications' || decodeURIComponent(urlHas.at(1)) === 'प्रकाशन') )
        {
          setPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'FacultyPublications', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'FacultyPublications', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'clubs-societies' || decodeURIComponent(urlHas.at(0)) === 'क्लब-सोसायटी') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          const sidebarData = await getSidebar([],5);
          setPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'ClubsSocietiesDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1,sp_sidebar: 1,sidebarData: sidebarData, sp_banner: 0, sp_name: 'ClubsSocietiesDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'glimpses' || decodeURIComponent(urlHas.at(0)) === 'झलकियाँ') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          setPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'GlimpsesDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'GlimpsesDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else if( (urlHas.at(0) === 'program' || decodeURIComponent(urlHas.at(0)) === 'प्रोग्राम') && (urlHas.at(1) === 'details' || decodeURIComponent(urlHas.at(1)) === 'विवरण') )
        {
          setPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'ProgramDetails', sp_htaccess: urlHas.at(-1) });
          currentPage({ sp_id: 0, sp_dynamic: 1, sp_banner: 0, sp_name: 'ProgramDetails', sp_htaccess: urlHas.at(-1) });
          setLoading(false);
        }
        else
        {
          if( urlHas.length === 1 )
          {
            setLavelZero(urlHas.at(0));
          }
          if( urlHas.length === 2 )
          {
            setLavelZero(urlHas.at(0));
            setLavelOne(urlHas.at(1));
          }
          if( urlHas.length === 3 )
          {
            setLavelZero(urlHas.at(0));
            setLavelOne(urlHas.at(1));
            setLavelTwo(urlHas.at(2));
          }
          if( urlHas.length === 4 )
          {
            setLavelZero(urlHas.at(0));
            setLavelOne(urlHas.at(1));
            setLavelTwo(urlHas.at(2));
            setLavelThree(urlHas.at(3));
          }      
          setPageUrl(urlHas.at(-1));
          //getInnerPage();
        }      
      }
      else
      {
        await getHomepage();
      }
    };
    loadPageData();
    if (location.pathname === '/' ) {
      fetchActivePopup();
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  const fetchActivePopup = async () => {
    try {
      const response = await fetch(global.config.API_URL + "popups/active");
      if (!response.ok) throw new Error('Failed to fetch popup data');

      const result = await response.json();
      if (result && result.length > 0) {
        setPopupData(result[0]); // ✅ take only first popup
        setShowPopup(true);
        sessionStorage.setItem('popupShown', 'yes');
      }
      if( global.config.IsPrint === true ) { console.info('ActivePopup:',result); }
    } catch (error) {
      console.error("Active Popup Error:", error.message);
    }
  };
  useEffect(() => 
  {    
    const getPage = async () => 
    {
      try 
      {
        if (PageUrl) 
        {
          if( global.config.IsPrint === true ) 
          {
            console.info("LavelZero:", LavelZero);
            console.info("LavelOne:", LavelOne);
            console.info("LavelTwo:", LavelTwo);
            console.info("LavelThree:", LavelThree);
            console.info("PageUrl:", PageUrl);
          }
          await getInnerPage();
        }
      } 
      catch (error) 
      {
        console.error('Error fetching page:', error);
      }
    };
    getPage();
    // eslint-disable-next-line
  }, [LavelZero, LavelOne, LavelTwo, LavelThree, PageUrl]);
  const getHomepage = async () => 
  {
    try 
    {
      setLoading(true);
      const response = await fetch(global.config.API_URL+"webPage/homepage");
      if (response.ok) 
      {
        const result = await response.json();
        if( result.length > 0 )
        {
          result[0].headerImage = await getHeaderImage(result[0]);
          result[0].pageSection = await getPageSection(result[0]);
          setPage(result[0]);
          currentPage(result[0]);
        }
        else
        {
          setPage(errorPage);
          currentPage(errorPage);
        }
        if( global.config.IsPrint === true ) { console.info('Homepage : Result',result); }
      }
    }
    catch (error) 
    {
      console.error('Homepage Error :', error.message);
    }
    finally
    {
      setLoading(false);
    }
  };
  const getInnerPage = async () => 
  {
    try 
    {
      setLoading(true);
      let pId = 0;
      if(LavelZero && LavelZero !== PageUrl )
      {
        const responseLavelZero = await fetch(global.config.API_URL+"webPage/byHtaccess/"+LavelZero);
        const resultLavelZero = await responseLavelZero.json();
        if( resultLavelZero.length > 0 )
        {
          pId = resultLavelZero[0].sp_id;
          if(LavelOne && LavelOne !== PageUrl)
          {
            const responseLavelOne = await fetch(global.config.API_URL+"webPage/byHtaccessWithParent/"+pId+'/'+LavelOne);
            const resultLavelOne = await responseLavelOne.json();
            if( resultLavelOne.length > 0 )
            {
              pId = resultLavelOne[0].sp_id;
              if(LavelTwo && LavelTwo !== PageUrl)
              {
                const responseLavelTwo = await fetch(global.config.API_URL+"webPage/byHtaccessWithParent/"+pId+'/'+LavelTwo);
                const resultLavelTwo = await responseLavelTwo.json();
                if( resultLavelTwo.length > 0 )
                {
                  pId = resultLavelTwo[0].sp_id;
                  if(LavelThree && LavelThree !== PageUrl)
                  {
                    const responseLavelThree = await fetch(global.config.API_URL+"webPage/byHtaccessWithParent/"+pId+'/'+LavelThree);
                    const resultLavelThree = await responseLavelThree.json();
                    if( resultLavelThree.length > 0 )
                    {
                      pId = resultLavelThree[0].sp_id;
                    } 
                  }
                } 
              }
            }
          }
        }
      }
      const apiFetch = ( pId > 0 ) ? 'webPage/byHtaccessWithParent/'+pId+'/'+PageUrl : 'webPage/byHtaccess/'+PageUrl;
      const response = await fetch(global.config.API_URL+apiFetch);
      const result = await response.json();
      if( result.length > 0 )
      {
        result[0].headerImage = await getHeaderImage(result[0]);
        result[0].sidebarData = ( result[0].sp_sidebar === 1 ) ? await getSidebar(result[0]) : [];
        result[0].pageSection = await getPageSection(result[0]);
        setPage(result[0]);
        currentPage(result[0]);
      }
      else
      {
        setPage(errorPage);
        currentPage(errorPage);
      }      
      if( global.config.IsPrint === true ) { console.info('InnerPage : Result',PageData); }
    } 
    catch (error) 
    {
      console.error('InnerPage Error :', error.message);
    }
    finally
    {
      setLoading(false);
    }
  };
  const getPageSection = async (sp) =>
  {
    var PageSection = [];
    try 
    {
      if( sp && sp.sp_id > 0 )
      {
        const response = await fetch(global.config.API_URL+"pageSection/"+sp.sp_id);
        const result = await response.json();
        if( result.length > 0 )
        {
          PageSection = result;
          if( global.config.IsPrint === true ) { console.info('Page Section : Result',result); }
        }
      }
      return PageSection;
    }
    catch (error) 
    {
      console.error('Page Section Error :', error.message);
      return PageSection;
    }
  };
  const getHeaderImage = async (sp) =>
  {
    var spHeaderImage = HeaderImage;
    try 
    {
      if( sp && sp.sp_id > 0 )
      {
        const response = await fetch(global.config.API_URL+"upload/details/0/"+sp.sp_id+"/spHeader");
        const result = await response.json();
        if( result.length > 0 )
        {
          spHeaderImage = global.config.uploadPath+result[0].up_fname+result[0].up_ext;
          if( global.config.IsPrint === true ) { console.info('Page Header Image : Result',result); }
        }
        else
        {
          if( sp.sp_p_id > 0 )
          {
            const presponse = await fetch(global.config.API_URL+"upload/details/0/"+sp.sp_p_id+"/spHeader");
            const presult = await presponse.json();
            if( presult.length > 0 )
            {
              spHeaderImage = global.config.uploadPath+presult[0].up_fname+presult[0].up_ext;
              if( global.config.IsPrint === true ) { console.info('Parent Page Header Image : Result',presult); }
            }
          }
        }
      }
      return spHeaderImage;
    }
    catch (error) 
    {
      console.error('HeaderImage Error :', error.message);
      return spHeaderImage;
    }
  };
  const getSidebar = async (sp,spId) =>
  {
    var sideBar = [];
    var pId = ( spId > 0 ) ? spId : firstParentPageId(sp.sp_p_id,sp);
    try 
    {
      if( pId > 0 )
      {
        const response = await fetch(global.config.API_URL+"menu/subMenu/"+pId);
        const result = await response.json();
        if( pId === 146 && sp.sp_id===146 )
        {
          sideBar = result;
        }
        else
        {
          var x = 0;        
          for (const sp of result) 
          {
            const sbResponse = await fetch(global.config.API_URL+"menu/subMenu/"+sp.sp_id);
            const sbResult = await sbResponse.json();
            result[x].submenu = sbResult;
            if( sbResult.length > 0 )
            {
              var y = 0;
              for (const sbp of sbResult)
              {
                const sbbResponse = await fetch(global.config.API_URL+"menu/subMenu/"+sbp.sp_id);
                const sbbResult = await sbbResponse.json();
                result[x].submenu[y].submenu = sbbResult;
                y++
              }
            }
            x++;
          }
          sideBar = result;
        }
        if( global.config.IsPrint === true ) { console.info('Sidebar Menu : Result',result); }
      }
      return sideBar;               
    }
    catch (error) 
    {
      console.error('Sidebar Menu : Error', error.message);
      return sideBar;
    }    
  };
  function firstParentPageId(pId,obj,lastObj) 
  {
    if (!obj || typeof obj !== 'object') { return obj; }
    const { parentPage, ...rest } = obj;
    if (!parentPage) 
    {
      if( pId > 0 && ( rest['sp_id'] === 3 || rest['sp_id'] === 146 ) )
      {
        return lastObj['sp_id'];
      }
      return rest['sp_id']; 
    }
    else
    {
      return firstParentPageId(pId,parentPage,obj);
    }
  }
  return (
    <React.Fragment>
      {popupData && (
        <DynamicPopup show={showPopup} data={popupData} onHide={() => setShowPopup(false)} />
      )}
    {isLoading ? (
      <Container fluid className='text-center position-relative bg-success-subtle' style={{minHeight:"72vh"}}>
        <Stack direction="horizontal" gap={3} className='position-absolute top-50 start-50 translate-middle'>
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <Spinner animation="grow" role="status" variant="warning" style={{width:"3rem",height:"3rem"}}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <Spinner animation="grow" role="status" variant="success" style={{width:"5rem",height:"5rem"}} >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <Spinner animation="grow" role="status" variant="danger" style={{width:"3rem",height:"3rem"}}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <Spinner animation="border" role="status" variant="info">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Stack>        
      </Container>
    ) : (
      <React.Fragment>
        <PageHeader pageData={PageData} />
        <main id="page-content" className="position-relative">
          <PageBody pageData={PageData} />
        </main>
      </React.Fragment>
    )}
    </React.Fragment>
  );
}
export default DynamicPage;
